import React from "react";
import { FloatingContainer } from "../../../../../Components/Wrappers";
import { Flex, Image } from "rebass/styled-components";
import { Title1 } from "../../../../../Components/Text";
import styled from "styled-components";
import { ShareContents } from "../../../../../Components/ShareOptions";

const StyledThumb = styled(Image)`
  display: flex;
  position: absolute;
  top: -130px;
  object-fit: contain;
  width: 100%;
  overflow: hidden;
  box-shadow: 0 0 20px 20px rgb(0 0 0 / 15%);
  color: #fff;
  max-width: 410px;
  height: auto;
  border-radius: 10px;
  @media (max-width: ${(props) => props.theme.breaks.narrow}) {
    max-width: 280px;
    top: -70px;
  }
`;

export function ShareModalContents({ card }: any) {
  return (
    <>
      <FloatingContainer maxWidth="450px" maxHeight="700px">
        <StyledFlex mb={10}>
          <StyledThumb
            src={`${process.env.REACT_APP_S3_PERSONALIZATION_BUCKET}/${card.ui.image}`}
          />
        </StyledFlex>
        <Flex
          flexDirection="column"
          alignItems="stretch"
          justifyContent="flex-start"
        >
          <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
          >
            <Title1 mb={5}>Share with your friends</Title1>
            <ShareContents card={card} />
          </Flex>
        </Flex>
      </FloatingContainer>
    </>
  );
}

const StyledFlex = styled(Flex)`
  position: relative;
  justify-content: center;
`;
